import * as React from "react"
import { COMMON_INPUT_STYLES } from "@digits-shared/DesignSystem/FormElements/Input"
import { type PrimitiveAtom, useAtom } from "jotai"
import styled from "styled-components"
import {
  InputGroup,
  PanelLabel,
} from "src/frontend/components/OS/Applications/CategoryManager/CategoryPanel/Shared"

const TextArea = styled.textarea<{ $invalid?: boolean }>`
  ${COMMON_INPUT_STYLES};
  resize: vertical;
`

interface CategoryDescriptionTextAreaProps {
  descriptionAtom: PrimitiveAtom<string>
}

export const CategoryDescriptionTextArea: React.FC<CategoryDescriptionTextAreaProps> = ({
  descriptionAtom,
}) => {
  const [description, setDescription] = useAtom(descriptionAtom)

  const onChange = React.useCallback(
    (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      setDescription(e.target.value)
    },
    [setDescription]
  )

  return (
    <InputGroup>
      <PanelLabel>Description (Optional)</PanelLabel>

      <TextArea
        name="description"
        placeholder="Enter a description…"
        value={description}
        onChange={onChange}
        rows={3}
      />
    </InputGroup>
  )
}
